// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import { EmailMessageTemplate} from "./types/emailTemplateTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedEmailTemplateApi = createApi({
    reducerPath: "cclTokenedEmailTemplateApi",
    tagTypes: ["templates"],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl + "ccl-access2/EmailTemplate/",
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllEmailTemplates: builder.query<EmailMessageTemplate[], void>({
            query: () => ({
                url: "templates/All",
                method: "GET",
            }),
            providesTags: (_, __, ___) => ["templates"],
        }),
        getEmailTemplateById: builder.query<EmailMessageTemplate, string>({
            query: (id) => ({
                url: `templates/${id}`,
                method: "GET",
            }),
            providesTags: (_, __, ___) => ["templates"],
        }),
        getEmailTemplatesByKeyword: builder.query<EmailMessageTemplate[], string>({
            query: (keyword) => ({
                url: `templates/search/${keyword}`,
                method: "GET",
            }),
            providesTags: (_, __, ___) => ["templates"],
        }),
        createEmailTemplate: builder.mutation<EmailMessageTemplate, EmailMessageTemplate>({
            query: (body) => ({
                url: `templates/create`,
                method: "PUT",
                body: body,
            }),
            invalidatesTags: ["templates"],
        }),
        updateEmailTemplate: builder.mutation<EmailMessageTemplate, EmailMessageTemplate>({
            query: (body) => ({
                url: `templates/${body.id}`,
                method: "POST",
                body: body,
            }),
            invalidatesTags: ["templates"],
        }),
        deleteEmailTemplate: builder.mutation<EmailMessageTemplate, string>({
            query: (id) => ({
                url: `templates/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["templates"],
        }),        
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetAllEmailTemplatesQuery,
    useGetEmailTemplateByIdQuery,
    useLazyGetEmailTemplateByIdQuery,
    useLazyGetEmailTemplatesByKeywordQuery,
    useCreateEmailTemplateMutation,
    useUpdateEmailTemplateMutation,
    useDeleteEmailTemplateMutation,
} = cclTokenedEmailTemplateApi;
